import React from 'react';

import Thumbnail from './Thumbnail';
import Name from './Name';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import { useContext } from 'react';
import { UserDetailsContext } from 'context/userDetailsContext';
import { useHistory, useLocation } from 'react-router-dom';

function GridItem({ item }) {
  const { handleBreadCrumbs, modals, setSelectedPreviewItem, onFilterChange, setPreviewList, files, fileManagerFilters } =
    useFileManagerContext();
  const userContext = useContext(UserDetailsContext);

  const { setShowPreview } = modals;

  const history = useHistory();
  const location = useLocation();

  const setQuery = (data) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('file_id', data?.object_id);

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const selectFile = (e) => {
    if (e.entry_type === 'folder') {
      handleBreadCrumbs(e);
      // setSelectedFolder(e.object_id);
      // let obj = {
      //   case_id: isGlobalFileManager || isClientFileManager ? '' : caseDetails.case_id,
      //   selectedFolder: e.object_id,
      //   selectedType: '',
      //   tag: '',
      //   query: '',
      //   folder_id: '',
      // };
      // getFiles(obj, currentView, pageLimit);

      // Check if this is a shared folder and current user is a client
      const isSharedFolder = e.folder_shared === true;
      const isClientUser = userContext?.access_level === 'client';
      const hasFolderId = e.object_id && e.object_id !== '' && e.object_id !== 'undefined';
      const isCurrentlyInSharedMode = fileManagerFilters?.shared_folder === true;

      // Set shared_folder: true when:
      // 1. Client user clicking INTO any folder with valid folder_id when already in shared mode, OR
      // 2. Client user clicking INTO a shared folder for the first time
      const shouldSetSharedFolder = isClientUser && hasFolderId && (isCurrentlyInSharedMode || isSharedFolder);

      let data = {
        target: {
          name: 'selectedFolder',
        },
        value: e.object_id,
        // Set shared_folder: true when client clicks any folder in shared mode or shared folder for first time
        // Otherwise preserve the current shared_folder state if it exists
        ...(shouldSetSharedFolder ? { shared_folder: true } : isCurrentlyInSharedMode ? { shared_folder: true } : {}),
        // Only set folder_shared and shared_contact_list for actually shared folders
        folder_shared: e.entry_type === 'folder' && isSharedFolder && e.file_shared_contact_id ? true : null,
        shared_contact_list: e.entry_type === 'folder' && isSharedFolder && e.file_shared_contact_id ? e.file_shared_contact_id : null,
      };
      onFilterChange(data);
    } else {
      setQuery(e);
      // setShowPreview(true);
      // setPreviewList(files);
      // setSelectedPreviewItem(e);

      // if (
      //   selectedItem &&
      //   selectedItem.file_type &&
      //   (selectedItem.file_type === "application/pdf" ||
      //     selectedItem.file_type === docTypeVal)
      // ) {
      //   pdfTronFile(selectedItem, selectedIndex, false);
      // } else {
      //   let find_index = fileList
      //     .filter((item) => item.entry_type !== "folder")
      //     .findIndex((item) => item.sk === e.sk && item.pk === e.pk);
      //   setSelectedIndex(find_index);
      //   setIsFilePreview(true);
      // }
    }
  };

  return (
    <div
      style={{
        ...(item.entry_type === 'image' ? { height: '100%' } : {}),
      }}
      className="pointer card-bg fileManager-item"
    >
      <Thumbnail item={item} selectFile={selectFile} />
      <Name item={item} selectFile={selectFile} />
    </div>
  );
}

export default GridItem;
